import queryString from 'query-string';
import { api, createErrorResponse } from './index';

const defaultLimit = 9999;

const defaultQuery = {
  attributes: [
    'uuid',
    'title',
    'state',
    'createdAt',
    'updatedAt',
    'createdByUser',
    'createdByUserName',
    'tags',
    'type',
  ],
};

export async function getPages(
  limit = defaultLimit,
  queryParams = defaultQuery,
) {
  try {
    const params = {
      n: limit,
      ...queryParams,
    };
    const query = queryString.stringify(params);
    const response = await api.get(`pages?${query}`);
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}

export async function deletePageById(uuid) {
  try {
    const response = await api.delete(`/admin/pages/${uuid}`); // FIXME: API is using singular
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}

export async function getPageById(uuid) {
  try {
    const response = await api.get(`page/${uuid}`); // FIXME: API is using singular
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}
export async function postNewPage(page) {
  try {
    const response = await api.post(`admin/pages`, page);
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}

export async function postPageUpdate(uuid, page) {
  try {
    const response = await api.post(`admin/pages/${uuid}`, page);
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}

export async function postPageRole(uuid, role) {
  try {
    const response = await api.post(
      `admin/pages/${uuid}/view/${encodeURI(role)}`,
    );
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}

export async function deletePageRole(uuid, role) {
  try {
    const response = await api.delete(
      `admin/pages/${uuid}/view/${encodeURI(role)}`,
    );
    return response;
  } catch (error) {
    console.error(error);
    return createErrorResponse(error);
  }
}
